import React from "react";
import { render } from "react-dom";

export default function Pricing() {
  return <div>This is Astroworker's pricing page.</div>;
}
